import React, { useState, useEffect } from "react";
import {Button, createTheme, Grid, IconButton, InputBase, ThemeProvider, Typography} from '@material-ui/core';
import {useHistory} from 'react-router-dom';
import useStyles from '../../assets/styles';
import { clickBack, devicePulseStatus } from '../../../utils';
import { RedirectIcon } from '../../../../components/Icons';
import { createJiraProject, getAllJiraStatuses, getJiraProject } from "../components/apiHelper";
import { Loader } from "../components/Loader";
import { ToasterComponent } from "../components/Toaster";
import { primaryGray } from "src/components/colors";
import { JiraDetailsComponent } from "./JiraDetialsComponent";
import { StatusMappingComponent } from "./StatusMappingComponent";
import { JiraProjectData } from "src/app/models";
import { ITSMTitleComponent } from "./ITSMTitleComponent";

const STEPS = [
    {
      text: "Jira Details",
      activate: true,
    },
    {
      text: "Status Mapping",
      activate: false,
    }
];

export const JIRAConfigurationComponent = () => {
    const theme = createTheme({
        typography: {
            fontFamily: "'Poppins', sans-serif",
        },
    });
    const classes = useStyles();
    const history = useHistory();
    const [steps, setSteps] = useState(STEPS);
    const [step, setStep] = useState(0);
    const [jiraBoard, setJiraBoard] = useState("");
    const [jiraURL, setJiraURL] = useState("");
    const [email, setEmail] = useState("");
    const [apiToken, setApiToken] = useState("");
    const [projectKey, setProjectKey] = useState("");
    const [isprojectExist, setIsProjectExist] = useState(false);
    const [statusMapping, setStatusMapping] = useState({});
    const [jiraStatuses, setJiraStatuses] = useState([]);
    const [projectDetail, setProjectDetail] = useState({
        jiraBoard: "",
        jiraURL: "",
        email: "",
        apiToken: "",
        projectKey: ""
    });
    const [errors, setErrors] = useState({
        nameError: null,
        urlError: null,
        emailError: null,
        tokenError: null,
        keyError:null
    })
    const [mappingErrors, setMappingErrors] = useState<any>({});

    //Toaster
    const [isToasterOpen, setIsToasterOpen] = useState(false)
    const [toasterMessage, setToasterMessage] = useState("")
    const [reqSuccess, setReqSuccess] = useState(false)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        updateStepActivation(step);
    }, [step]);
    
    function updateStepActivation(currentStep) {
        const updatedSteps = steps.map((step, index) => ({
            ...step,
            activate: index === currentStep,
        }));
        setSteps(updatedSteps);
    }

    const handleJiraStatusChange = (index: number, selectedStatus: string) => {
        setStatusMapping((prev) => {
            const updatedMapping = {
                ...prev,
                [index]: selectedStatus,
            };
    
            setMappingErrors((prevErrors) => {
                const newErrors = { ...prevErrors };
                if (selectedStatus && selectedStatus.trim() !== "") {
                    newErrors[index] = null;
                }
                return newErrors;
            });
    
            return updatedMapping;
        });
    };    

    const handleInputChange = async (event) => {
        const { name, value } = event.target;
        if(name === "boardName"){
            setJiraBoard(value);
            setErrors({...errors, nameError: null});
        }
        else
        if(name === "url"){
            setJiraURL(value);
            setErrors({...errors, urlError: null});
        }
        else if(name === "email"){
            setEmail(value);
            setErrors({...errors, emailError: null});
        }
        else if(name === "apiToken"){
            setApiToken(value);
            setErrors({...errors, tokenError: null});
        }
        else if(name === "projectKey"){
            setProjectKey(value);
            setErrors({...errors, keyError: null});
        }
    };

    const resetFormFields = () => {
        setJiraURL("");
        setEmail("");
        setApiToken("");
        setProjectKey("");
        setErrors({
            nameError: null,
            urlError: null,
            emailError: null,
            tokenError: null,
            keyError:null
        });
    }

    const handleBack = () => {
        setStep(0);
        setSteps(STEPS);
        resetFormFields();
        history.push("/TestAutomation");
    }

    const handleRedirect = () => {
        history.push({
            pathname: "/deviceFailure",
            state: { isRedirect: true }
        });
        const event = new CustomEvent('deviceFailureClicked');
        window.dispatchEvent(event);
    }

    
    const fetchAllJiraStatuses = async () => {
        try {
            setLoading(true);
            const response = await getAllJiraStatuses();
            if (response.status === 200) {
                const data = response.data;

            // Extract all status names from each issue type
            const allStatusNames = data.flatMap((issueType: any) =>
                issueType.statuses.map((status: any) => status.name)
            );

            const uniqueStatusNames = [...new Set(allStatusNames)];

            setJiraStatuses(uniqueStatusNames);
            } else{
                console.log("Error fetching data");
            }
        }
        catch(error) {
            setIsToasterOpen(true);
            setReqSuccess(false);
            setToasterMessage(error.message);
        }
        finally {
            setLoading(false);
            setTimeout(() => setIsToasterOpen(false), 2000);
        }
    }

    useEffect(() => {
        const getProjectDetail = async () => {
            try {
                setLoading(true);
                const response = await getJiraProject();
                if (response.status === 200) {
                    const data = response.data;
                    if(data.jiraBoard !== null && data.jiraBoard !== "" && data.jiraBoard !== undefined) {    
                        setIsProjectExist(true);
                        setProjectDetail(data);
                    }
                } else{
                    console.log("Error fetching data");
                }
            } catch(error) {
            } finally {
                setLoading(false);
            }
        }
        getProjectDetail();
    }, []);

    const validationForm = async () => {
        let isError = false;
        let errors: any = {};
        if(jiraBoard.trim() === ""){
            errors.nameError = "Jira Board Name Required";
            isError = true;
        }    
        if(jiraURL.trim() === ""){
            errors.urlError =  "Jira Url Required";
            isError = true;
        }
        if(email.trim() === ""){
            errors.emailError = "Reporter Email Required";
            isError = true;
        } else {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(email)) {
                errors.emailError = "Please Enter a Valid Email Address";
                isError = true;
            }
        }
        if(apiToken.trim() === ""){
            errors.tokenError = "Api Token Required";
            isError = true;
        }
        if(projectKey.trim() === ""){
            errors.keyError = "Project Key Required";
            isError = true;
        }
        setErrors(errors);
        return isError;
    }

    const validateStatusMapping = () => {
        let hasError = false;
        const errors: Record<number, string> = {};
    
        devicePulseStatus.forEach((statusObj, index) => {
            const selectedStatus = statusMapping[index];
            if (!selectedStatus || selectedStatus.trim() === "") {
                errors[index] = `Mapping this status is required`;
                hasError = true;
            }
        });
    
        setMappingErrors(errors);
        return hasError;
    };   

    const handleSubmit = async () => {
        console.log("step", step);
        if(step === 0){
            const validationError = await validationForm();
            if (validationError) {
                return;
            }
        } else if (step === 1) {
            const mappingValidationError = validateStatusMapping();
            if (mappingValidationError) {
                return;
            }
        }
        let data: JiraProjectData = {
            jiraBoard: jiraBoard.trim(),
            jiraURL: jiraURL.trim(),
            email: email.trim(),
            apiToken: apiToken.trim(),
            projectKey: projectKey.trim(),
        };
        if (step === 1) {
            const statusMap = {};
            devicePulseStatus.forEach((item, index) => {
                const selectedJiraStatus = statusMapping[index];
                if (selectedJiraStatus) {
                    statusMap[item.status] = selectedJiraStatus;
                }
            });
        
            data = {
                ...data,
                statusMap
            };
        }
        try {
            setLoading(true);
            const response = await createJiraProject(data);
            if(response.status === 200){
                setIsToasterOpen(true);
                setReqSuccess(true);
                setToasterMessage("Configurations Saved Successfully");
                if(step === 0){
                    setStep(1);
                    await fetchAllJiraStatuses();
                }
                if(step === 1){
                    setIsToasterOpen(true);
                    setReqSuccess(true);
                    setToasterMessage("Status Mapped Successfully");
                    resetFormFields();
                    setTimeout(() => history.push("/TestAutomation"), 2000);
                }
            } 
        } catch (error) {
            if(error.status === 422){
                setIsToasterOpen(true);
                setReqSuccess(false);
                setToasterMessage(error.data.message);
            }
        } finally {
            setLoading(false)
            setTimeout(() => setIsToasterOpen(false), 2000);
        }
    }

    function renderStepsComponent() {
        if(step === 0) {
            return <JiraDetailsComponent 
                jiraBoard={jiraBoard}
                jiraURL={jiraURL}
                email={email}
                apiToken={apiToken}
                projectKey={projectKey}
                handleInputChange={handleInputChange}
                handleSubmit={handleSubmit}
                handleRedirect={handleRedirect}
                decreaseStep={decreaseStep}
                increaseStep={increaseStep}
                nameError={errors.nameError}
                urlError={errors.urlError}
                emailError={errors.emailError}
                tokenError={errors.tokenError}
                keyError={errors.keyError}
                isprojectExist={isprojectExist}
                projectDetail={projectDetail}
            />
        } else if(step === 1) {
            return <StatusMappingComponent
                    devicePulseStatus={devicePulseStatus}
                    jiraStatuses={jiraStatuses}
                    increaseStep={increaseStep}
                    decreaseStep={decreaseStep}
                    handleJiraStatusChange={handleJiraStatusChange}
                    statusMapping={statusMapping}
                    setStatusMapping={setStatusMapping}
                    mappingErrors={mappingErrors}
                    isServiceNow={false}
            />
        }
    }

    async function increaseStep() {
        await handleSubmit();
    }    

    function decreaseStep() {
        if(step === 0){
            handleBack();
        }
        setStep(prevStep => 
            Math.max(prevStep - 1, 0)
        );
    }

    return (
        <ThemeProvider theme={theme}>
            <div className="testing">
                <ITSMTitleComponent />
                <Grid container className={classes.circleContainer}>
                    {steps.map((step, index) => (
                    <React.Fragment key={index}>
                        <Grid item xs={2} md={1}>
                        <Grid container direction="column" alignItems="center">
                            <Grid item>
                            <Circle number={index + 1} active={step.activate} completed={steps.findIndex(s => s.activate) > index} />
                            </Grid>
                            <Grid item>
                            <Typography
                                style={{
                                fontSize: "12px",
                                paddingTop: "15px",
                                fontFamily: "Poppins, sans-serif",
                                color: step.activate ? '#005B96' : primaryGray,
                                }}
                            >
                                {step.text}
                            </Typography>
                            </Grid>
                        </Grid>
                        </Grid>
                        {index !== steps.length - 1 && (
                        <Grid item xs={2} md={2}>
                            <hr
                            style={{
                                marginTop: "32px",
                                opacity: steps[index + 1].activate ? "1" : "0.12",
                            }}
                            color={
                                steps[index + 1].activate
                                ? "#005B96"
                                : "rgba(112, 112, 112, .12)"
                            }
                            />
                        </Grid>
                        )}
                    </React.Fragment>
                    ))}
                </Grid>
                <Grid item style={{marginTop:'20px'}}>
                    {renderStepsComponent()}
                </Grid>                  
            </div>
            <Loader loading={loading} />
            <ToasterComponent 
                reqSuccess={reqSuccess} 
                message={toasterMessage} 
                toaster={isToasterOpen} 
            />
        </ThemeProvider>
    )
}

const Circle = (props) => {
  const paddedNumber = (props.number).toString().padStart(2, '0');
  return (
    <div>
      <div
        style={{
          borderRadius: "50%",
          width: "65px",
          height: "65px",
          backgroundColor: props.completed ? "#005B96" : "white",
          border: props.active ? "2px solid #005B96" : "0.25px solid #8F8F8F",
          textAlign: "center",
          paddingTop: "10px",
          boxShadow: "0px 4px 8px #0000001F",
        }}
      >
        <h5 style={{
          paddingTop: "10px",
          fontSize: "16px",
          color: props.active ? "#005B96" : (props.completed ? "white" : primaryGray)
        }}>
          {paddedNumber}
        </h5>
      </div>
    </div>
  );
};